exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ":host {\n  margin: 5px; }\n  :host .btn-to-action {\n    padding-right: 0 !important;\n    padding-top: 0 !important;\n    padding-bottom: 0 !important; }\n  :host .icon-left {\n    padding-right: 5px; }\n  :host .icon-right {\n    border-left: 1px solid rgba(119, 119, 119, 0.4);\n    padding: 16px 14px 12px 14px;\n    font-size: 1.4em;\n    margin-left: 15px; }\n  :host .btn-last {\n    margin-top: 10px !important;\n    padding: 8px 60px !important;\n    padding-right: 0 !important; }\n  :host .btn-last-icon {\n    margin-left: 50px !important; }\n  :host .btn-coti {\n    font-size: 1.6em;\n    font-weight: bold; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/core/component/core/button/button.component.scss
// module id = 903
// module chunks = 0